import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import {
  AppMultiSelect,
  AppRemixIcon,
  AppSingleSelect,
} from '@/layout/AppComponents';
import { axiosPath } from '../../../../routing/helpers/router';
import useIsMounted from '../../hooks/useIsMounted';

/*
 * format:  name (default): "Name"
 *          user: "User"
 *          name-email: "Name - Email"
 */
export default function UserSelect(props) {
  const {
    value,
    clientID,
    onChange,
    isMulti = true,
    format = 'name',
    title = undefined,
    plantHex = undefined,
  } = props;
  const isMounted = useIsMounted();
  const [options, setOptions] = useState(null);

  // > LOAD USERS //
  const loadUsers = useCallback(
    async () =>
      axios
        .post(axiosPath('api_r_user_global_select_user'), {
          clientID,
          format,
          plantHex,
        })
        .then((r) => {
          if (isMounted.current) {
            setOptions(r.data);
          }
        }),

    [clientID, format]
  );

  useEffect(() => {
    loadUsers();
  }, []);
  // < LOAD USERS //

  if (isMulti) {
    return (
      <AppMultiSelect
        icon={<AppRemixIcon icon="user" />}
        options={options}
        title={title || 'Usuarios'}
        placeholder="Selecciona uno o varios usuarios"
        value={value}
        onChange={(opt) => onChange(opt)}
        allowSelectAll
        isLoading={!options}
        hasSearchBox
        hasSelectOptions
      />
    );
  }

  return (
    <AppSingleSelect
      icon={<AppRemixIcon icon="user" />}
      options={options}
      title={title || 'Usuario'}
      placeholder="Selecciona un usuario"
      value={value}
      onChange={(opt) => onChange(opt)}
      isLoading={!options}
      hasSearchBox
    />
  );
}
